import { usePermanentLocations } from "components";
import { useTypedQuery } from "hooks";
import { useGetUsersDashboardFilters } from "modules/UsersDashboard/components/UsersDashboardFilters/hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useUsersQuery = () => {
  const { locations } = usePermanentLocations();
  const {
    filters: { dealer_ids, dealer_location_ids, ...rest }
  } = useGetUsersDashboardFilters();

  const getDealerLocationIds = () => {
    if (dealer_location_ids.length) return dealer_location_ids;

    const activeLocations = locations.filter(loc => loc.active);

    if (!dealer_ids.length) return activeLocations.map(loc => loc.id);
    return activeLocations.filter(location => dealer_ids.includes(location.dealer_id)).map(loc => loc.id);
  };

  const { data, refetch, isFetching } = useTypedQuery({
    queryKey: UsersDashboardQueryKeys.users,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { ...rest, dealer_location_ids: getDealerLocationIds() }, baseUrl)).data,
    enabled: false
  });

  return { refetch, users: data?.users || [], nbItems: data?.nb_items || 0, nbPages: data?.nb_pages || 1, isUsersLoading: isFetching };
};
